/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { isCanada, isClient } from '@tcp/core/src/utils';
import {
  getIsGuest,
  isRememberedUser,
  isPlccUser,
  getUserId,
  getSpendLeftForNextPerk,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { fetchDyRecommendationsData } from '@tcp/core/src/components/common/molecules/DyRecommendations/container/DyRecommendations.actions';
import { getATB1Rec } from '@tcp/core/src/components/common/molecules/DyRecommendations/container/DyRecommendations.selector';
import { getCurrencyAttributes } from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import { getFavoriteStoreActn } from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.actions';
import {
  getAlternateBrandName,
  getFirstTimeCaptureBanner,
  getFirstTimeCaptureShopMenu,
} from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.selectors';
import { getAlternateBrand } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import AddedToBagReducer from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.reducer';
import AddedToBagSaga from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.saga';
import CartTileReducer from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.reducer';
import CartPageSaga from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.saga';
import {
  getIsBossEnabled,
  getIsSuppressGetOrderDetails,
  getIsAvoidGetOrderDetails,
  getABTestOffStyleWith,
  getIsPhysicalMpackEnabled,
  getIsATBHidePoints,
  getOptimisticAddBagModal,
  getIsNewReDesignEnabled,
  getIsATBModalBackAbTestNewDesign,
  getIsFBTAbTestEnabled,
  getIsAddedToBagRedesignEnabled,
  getIsOffersDisplayEnabled,
  getIsPersistPointsApiEnabled,
  getIsBundleTrackerEnabled,
  getIsSyteEnabled,
  getIsUserPersonalizationEnabled,
  getUserPersonalizationApiEnabled,
  isPlacePerkEnabled,
  getPlacePerksDisplayThreshold,
  getIsAppRatingPromptEnabled,
  getIsHardcodeSizeMapEnabled,
  getHardcodeSizeMapConfig,
  getDynamicShippingCharge,
  getIsFreeShippingProgressBarDisabled,
  getIsNewATBProductInformationDesign,
  freeShippingMessageForPromos,
  getIsBackToQuickviewCTAEnabled,
  getNewGlobalErrorMessage,
  getIsLoyaltyTieringEnabled,
  getIsDyEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { PRODUCT_PICKUP_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import {
  getFavoritePage,
  getIsQVOpen,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors.js';
import { clearAllSelectedAccessories } from '@tcp/core/src/components/common/molecules/Accessories/container/Accessories.actions.js';
import { getBopisInventoryDetailsAction } from '@tcp/core/src/components/common/organisms/ProductPickup/container/ProductPickup.actions';
import * as PickupSelectors from '@tcp/core/src/components/common/organisms/ProductPickup/container/ProductPickup.selectors';
import { updateCartItem } from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.actions';
import { setClickAnalyticsData, trackClick, trackPageView } from '@tcp/core/src/analytics/actions';
import { clearRecommendationData } from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.actions';
import { getServerTimeFromState } from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.selectors';
import getLoyaltyOrderItemPoints from '@tcp/core/src/reduxStore/selectors/customerLoyalty.selectors';
import {
  closeAddedToBag,
  AddToPickupError,
  clearAddToBagModalError,
  addToCartEcomAtbLoadedNewDesign,
  addToBagPayloadTotalCount,
  saveUserBrowseHistory,
} from './AddedToBag.actions';
import {
  getAddedToBagData,
  getAddedToBagModalError,
  isOpenAddedToBag,
  isOpenAddedToBagMinimal,
  getQuantityValue,
  getAddedToBagLoaderState,
  getLoyaltyAPICallStatus,
  getATbAPICallStatus,
  getAddedToBagInterval,
  getPointsSummary,
  getEnableKeepShoppingCTA,
  getMultipackProductType,
  getAddedToBagGhostLoaderState,
  getAddedToBagGhostLoaderCompleteState,
  getIsMpackItem,
  getAddedToPickupError,
  getEnableBOPISPickupInstead,
  getAddedToBagError,
  getPayloadData,
  getFbtDisplayedState,
  getIsFbtCompletedState,
  getATBItemInfo,
  getIsFbtEnabledState,
  getLoyaltyPointsRequestPayload,
  getMultipleItemsAddedToBagError,
  getAddedToBagPayloadItemCount,
  getATBMaintenanceStatus,
  getOfferPriceIsLoading,
  getATBUnavailableProducts,
  getIsInventoryUnavailable,
} from './AddedToBag.selectors';
import AddedToBag from '../views/AddedToBag.view';
import { getIsInternationalShipping } from '../../../../../reduxStore/selectors/session.selectors';
import BagPageSelectors, {
  getFreeShippingThresholdValue,
  getIsFreeShippingCouponApplied,
  isECOMStatus,
  isMixedOrderStatus,
  getFreeShippingType,
} from '../../BagPage/container/BagPage.selectors';
import checkoutSelectors from '../../Checkout/container/Checkout.selector';
import { getUserLoggedInState } from '../../../account/User/container/User.selectors';
import ProductPickupReducer from '../../../../common/organisms/ProductPickup/container/ProductPickup.reducer';
import ProductPickupStoreSaga from '../../../../common/organisms/ProductPickup/container/ProductPickup.saga';
import { getOrderShipments } from '../../CartItemTile/container/CartItemTile.selectors';
import { getProductTotal } from '../../common/organism/OrderLedger/container/orderLedger.selector';
import {
  closeQuickViewModal,
  setPlpDataForQuickView,
  setSlpDataForQuickView,
  setQuickViewProductDetailPageTitle,
} from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { setUpdateCheckbox } from '../../../../common/organisms/Promotions/container/Promotions.action';

export class AddedToBagContainer extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (isEqual(nextProps, this.props)) {
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    const { isNewReDesignEnabled, isATBModalBackAbTestNewDesign } = this.props;
    if (!isNewReDesignEnabled || !isATBModalBackAbTestNewDesign) {
      this.handleCloseModal();
    }
  }

  handleCloseModal = () => {
    const { closeModal, clearModalError } = this.props;
    requestAnimationFrame(() => {
      closeModal();
      clearModalError();
    });
  };

  hideHeaderWhilePaypalView = (hide) => {
    const { navigation } = this.props;
    navigation.setParams({ headerMode: hide });
  };

  handleBackButtonClick = () => {
    const quickViewModalContentWrapper = document.querySelector(
      '.quick-view-modal-content-wrapper'
    );
    const addedToBagModalContentWrapper = document.querySelector(
      '.added-to-bag-modal-content-wrapper'
    );
    const quickViewModalOverlay = document.querySelector('.quick-view-modal-overlay');
    const addedToBagModalOverlay = document.querySelector('.added-to-bag-modal-overlay');

    if (addedToBagModalOverlay) {
      addedToBagModalOverlay.classList.add('hide-overlay');
    }

    if (addedToBagModalContentWrapper) {
      addedToBagModalContentWrapper.classList.add('hide-added-to-bag-content');
    }

    if (quickViewModalContentWrapper) {
      quickViewModalContentWrapper.classList.remove('hide-qv-content');
    }

    if (quickViewModalOverlay) {
      quickViewModalOverlay.classList.remove('hide-overlay');
    }
  };

  closeModal(event, isBackToQuickViewButtonClick) {
    const { isOpenDialogMinimal, isQvModalOpen, isBackToQuickviewCTAEnabled, closeQvModal } =
      this.props;
    if (event) event.preventDefault();
    if (isOpenDialogMinimal?.callBack) isOpenDialogMinimal.callBack();
    this.handleCloseModal();

    if (isClient() && isBackToQuickviewCTAEnabled && isBackToQuickViewButtonClick) {
      this.handleBackButtonClick();
    }

    if (
      isClient() &&
      isBackToQuickviewCTAEnabled &&
      isQvModalOpen &&
      !isBackToQuickViewButtonClick
    ) {
      requestAnimationFrame(() => {
        closeQvModal();
      });
    }
  }

  render() {
    const {
      addedToBagData,
      addToBagModalError,
      isOpenDialog,
      isOpenDialogMinimal,
      quantity,
      navigation,
      isInternationalShipping,
      isPayPalWebViewEnable,
      isPayPalButtonRendered,
      isPayPalEnabled,
      router,
      closeModal,
      addedToBagLoaderState,
      addedToBagInterval,
      totalBagItems,
      pointsSummary,
      bagLoading,
      isBossEnabled,
      isSuppressGetOrderDetails,
      isVenmoAppInstalled,
      isVenmoEnabled,
      isAvoidGetOrderDetails,
      enableKeepShoppingCTA,
      multipackProductType,
      isABTestOffStyleWith,
      isPhysicalMpackEnabled,
      addedToBagGhostLoaderState,
      addedToBagGhostLoaderCompleteState,
      isMpackItem,
      getBopisInventoryDetails,
      userDefaultStore,
      bopisItemInventory,
      addItemToCartInPickup,
      addToPickupError,
      setAddToPickupError,
      showBOPISPickupInstead,
      isABTestHidePoints,
      isUserGuest,
      isRememberedUserState,
      getFavoriteStore,
      addedToBagError,
      isOptmisticAddToBagModal,
      isNewReDesignEnabled,
      isATBModalBackAbTestNewDesign,
      loyaltyAPICallStatus,
      aTbAPICallStatus,
      aTbMaintenanceStatus,
      addToBagEcomNewAfterModalOpened,
      openStatePayloadData,
      isPlcc,
      alternateBrand,
      alternateBrandFromPickup,
      isFBTAbTestEnabled,
      isFBTDisplayed,
      isFbtCompleted,
      itemInfo,
      isFBTEnabled,
      isAddedToBagRedesignEnabled,
      loyaltyOrderItems,
      isOffersDisplayEnabled,
      currencyAttributes,
      clearSelectedAccessories,
      addToBagMultipleItemError,
      isLoyaltyPointsEnabled,
      firstTouchValue,
      payloadItemCount,
      isBundleTrackerEnabled,
      isFavoritePage,
      firstTouchShopMenu,
      route,
      isSyteEnabled,
      userId,
      isUserPersonalizationEnabled,
      isUserPersonalizationApiEnabled,
      saveUserPreferences,
      isFromStoreModal,
      isPlpPaginationEnabledStatus,
      isUserLoggedIn,
      placePerkEnabled,
      displayThreshold,
      spendLeftForNextPerk,
      trackRatingPopupClicks,
      trackPageLoad,
      IsAppRatingPromptEnabled,
      isHardcodeSizeMapEnabled,
      hardcodeSizeMapConfig,
      shipments,
      freeShippingThreshold,
      productTotal,
      dynamicShippingCharge,
      shippingMethodSelected,
      isFreeShippingProgressBarDisabled,
      isShippingOrder,
      isMixedOrder,
      isNewATBProductInformationDesignEnabled,
      isFreeShippingCouponApplied,
      isQvModalOpen,
      closeQvModal,
      offerPriceIsLoading,
      freeShippingPromoType,
      freeShippingMessageForPromosEnabled,
      atbUnavailableProducts,
      isBackToQuickviewCTAEnabled,
      newGlobalErrorMessageEnabled,
      isInventoryUnavailable,
      loyaltyOrderItemPoints,
      isLoyaltyTieringEnabled,
      serverTime,
      loadDyRecommendations,
      isDyEnabled,
      atb1Rec,
    } = this.props;
    const isATBHidePoints =
      isABTestHidePoints && isUserGuest && !isCanada() && !isRememberedUserState;
    const primaryBrand = addedToBagData && addedToBagData.primaryBrand;
    const alternateBrandFromUrl = addedToBagData && addedToBagData.alternateBrand;
    return (
      <AddedToBag
        openState={isNewReDesignEnabled ? isOpenDialogMinimal : isOpenDialog}
        openStatePayloadData={openStatePayloadData}
        closeModal={closeModal}
        router={router}
        onRequestClose={this.closeModal}
        showBOPISPickupInstead={showBOPISPickupInstead}
        addedToBagData={addedToBagData}
        addToBagModalError={addToBagModalError}
        getBopisInventoryDetails={getBopisInventoryDetails}
        bopisItemInventory={bopisItemInventory}
        addItemToCartInPickup={addItemToCartInPickup}
        addToPickupError={addToPickupError}
        setAddToPickupError={setAddToPickupError}
        userDefaultStore={userDefaultStore}
        isInternationalShipping={isInternationalShipping}
        quantity={quantity}
        handleContinueShopping={this.closeModal}
        navigation={navigation}
        isPayPalWebViewEnable={isPayPalWebViewEnable}
        isPayPalButtonRendered={isPayPalButtonRendered}
        isPayPalEnabled={isPayPalEnabled}
        hideHeader={this.hideHeaderWhilePaypalView}
        addedToBagLoaderState={addedToBagLoaderState}
        addedToBagInterval={addedToBagInterval}
        totalBagItems={totalBagItems}
        pointsSummary={pointsSummary}
        bagLoading={bagLoading}
        isBossEnabled={isBossEnabled}
        isSuppressGetOrderDetails={isSuppressGetOrderDetails}
        isVenmoAppInstalled={isVenmoAppInstalled}
        isVenmoEnabled={isVenmoEnabled}
        isAvoidGetOrderDetails={isAvoidGetOrderDetails}
        enableKeepShoppingCTA={enableKeepShoppingCTA}
        multipackProductType={multipackProductType}
        isABTestOffStyleWith={isABTestOffStyleWith}
        isPhysicalMpackEnabled={isPhysicalMpackEnabled}
        addedToBagGhostLoaderState={addedToBagGhostLoaderState}
        addedToBagGhostLoaderCompleteState={addedToBagGhostLoaderCompleteState}
        isMpackItem={isMpackItem}
        isATBHidePoints={isATBHidePoints}
        getFavoriteStore={getFavoriteStore}
        addedToBagError={addedToBagError}
        isOptmisticAddToBagModal={isOptmisticAddToBagModal}
        isNewReDesignEnabled={isNewReDesignEnabled}
        isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
        loyaltyAPICallStatus={loyaltyAPICallStatus}
        aTbAPICallStatus={aTbAPICallStatus}
        aTbMaintenanceStatus={aTbMaintenanceStatus}
        addToBagEcomNewAfterModalOpened={addToBagEcomNewAfterModalOpened}
        isPlcc={isPlcc}
        primaryBrand={primaryBrand}
        alternateBrand={alternateBrand || alternateBrandFromUrl || alternateBrandFromPickup}
        isFBTEnabled={isFBTAbTestEnabled || isFBTEnabled}
        isFBTDisplayed={isFBTDisplayed}
        isFbtCompleted={isFbtCompleted}
        itemInfo={itemInfo}
        isAddedToBagRedesignEnabled={isAddedToBagRedesignEnabled}
        loyaltyOrderItems={loyaltyOrderItems}
        isOffersDisplayEnabled={isOffersDisplayEnabled}
        currencyAttributes={currencyAttributes}
        clearSelectedAccessories={clearSelectedAccessories}
        addToBagMultipleItemError={addToBagMultipleItemError}
        isLoyaltyPointsEnabled={isLoyaltyPointsEnabled}
        firstTouchBannerValue={firstTouchValue}
        firstTouchShopMenu={firstTouchShopMenu}
        payloadItemCount={payloadItemCount}
        isBundleTrackerEnabled={isBundleTrackerEnabled}
        isFavoritePage={isFavoritePage}
        route={route}
        isSyteEnabled={isSyteEnabled}
        userId={userId}
        isUserPersonalizationEnabled={isUserPersonalizationEnabled}
        isUserPersonalizationApiEnabled={isUserPersonalizationApiEnabled}
        saveUserPreferences={saveUserPreferences}
        isUserGuest={isUserGuest}
        isFromStoreModal={isFromStoreModal}
        isPlpPaginationEnabledStatus={isPlpPaginationEnabledStatus}
        isUserLoggedIn={isUserLoggedIn}
        isPlacePerkEnabled={placePerkEnabled}
        trackRatingPopupClicks={trackRatingPopupClicks}
        trackPageLoad={trackPageLoad}
        displayThreshold={displayThreshold}
        spendLeftForNextPerk={spendLeftForNextPerk}
        IsAppRatingPromptEnabled={IsAppRatingPromptEnabled}
        isHardcodeSizeMapEnabled={isHardcodeSizeMapEnabled}
        hardcodeSizeMapConfig={hardcodeSizeMapConfig}
        shipments={shipments}
        freeShippingThreshold={freeShippingThreshold}
        productTotal={productTotal}
        dynamicShippingCharge={dynamicShippingCharge}
        shippingMethodSelected={shippingMethodSelected}
        isFreeShippingProgressBarDisabled={isFreeShippingProgressBarDisabled}
        isShippingOrder={isShippingOrder}
        isMixedOrder={isMixedOrder}
        isNewATBProductInformationDesignEnabled={isNewATBProductInformationDesignEnabled}
        isFreeShippingCouponApplied={isFreeShippingCouponApplied}
        isQvModalOpen={isQvModalOpen}
        closeQvModal={closeQvModal}
        offerPriceIsLoading={offerPriceIsLoading}
        freeShippingPromoType={freeShippingPromoType}
        freeShippingMessageForPromosEnabled={freeShippingMessageForPromosEnabled}
        isBackToQuickviewCTAEnabled={isBackToQuickviewCTAEnabled}
        atbUnavailableProducts={atbUnavailableProducts}
        newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
        isInventoryUnavailable={isInventoryUnavailable}
        loyaltyOrderItemPoints={loyaltyOrderItemPoints}
        isLoyaltyTieringEnabled={isLoyaltyTieringEnabled}
        serverTime={serverTime}
        loadDyRecommendations={loadDyRecommendations}
        isDyEnabled={isDyEnabled}
        atb1Rec={atb1Rec}
      />
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch(closeAddedToBag());
      dispatch(setUpdateCheckbox(false));
    },
    clearModalError: () => {
      dispatch(clearAddToBagModalError());
    },
    getBopisInventoryDetails: (payload) => {
      dispatch(getBopisInventoryDetailsAction(payload));
    },
    addItemToCartInPickup: (payload) => {
      dispatch(updateCartItem(payload));
    },
    setAddToPickupError: (payload) => {
      dispatch(AddToPickupError(payload));
    },
    getFavoriteStore: (payload) => {
      dispatch(getFavoriteStoreActn(payload));
    },
    addToBagEcomNewAfterModalOpened: (payload) => {
      dispatch(addToCartEcomAtbLoadedNewDesign(payload));
    },
    clearSelectedAccessories: () => {
      dispatch(clearAllSelectedAccessories());
    },
    addToBagPayloadTotalCountAction: (payload) => {
      dispatch(addToBagPayloadTotalCount(payload));
    },
    saveUserPreferences: (payload) => {
      dispatch(saveUserBrowseHistory(payload));
    },
    clearRecommendationDataForAddedToBag: (payload) => {
      dispatch(clearRecommendationData(payload));
    },
    trackRatingPopupClicks: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));
      setTimeout(() => {
        dispatch(trackClick(payload));
      }, 250);
    },
    trackPageLoad: (payload, customData) => {
      dispatch(setClickAnalyticsData(customData));
      setTimeout(() => {
        dispatch(trackPageView(payload));
        setTimeout(() => {
          dispatch(setClickAnalyticsData({}));
        }, 1000);
      }, 100);
    },
    closeQvModal: () => {
      dispatch(setQuickViewProductDetailPageTitle(''));
      dispatch(closeQuickViewModal({ isModalOpen: false }));
      dispatch(setPlpDataForQuickView(null));
      dispatch(setSlpDataForQuickView(null));
    },
    loadDyRecommendations: (payload) => {
      dispatch(fetchDyRecommendationsData(payload));
    },
  };
};

const mapStateToProps = (state) => {
  const { isVenmoAppInstalled, getIsVenmoEnabled } = checkoutSelectors;
  const defaultStoreObj = {};
  const { getUserDefaultStore } = PickupSelectors;
  const defaultStore = getUserDefaultStore(state) || defaultStoreObj;
  return {
    addedToBagData: getAddedToBagData(state),
    addToBagModalError: getAddedToBagModalError(state),
    pointsSummary: getPointsSummary(state),
    isOpenDialog: isOpenAddedToBag(state),
    isOpenDialogMinimal: isOpenAddedToBagMinimal(state),
    openStatePayloadData: getPayloadData(state),
    quantity: getQuantityValue(state),
    isInternationalShipping: getIsInternationalShipping(state),
    isPayPalWebViewEnable: BagPageSelectors.getPayPalWebViewStatus(state),
    isPayPalButtonRendered: BagPageSelectors.isPayPalButtonRenderDone(state),
    addedToBagLoaderState: getAddedToBagLoaderState(state),
    addedToBagInterval: getAddedToBagInterval(state),
    totalBagItems: BagPageSelectors.getTotalItems(state),
    isPayPalEnabled: BagPageSelectors.getIsPayPalEnabled(state),
    bagLoading: BagPageSelectors.isBagLoading(state),
    isBossEnabled: getIsBossEnabled(state),
    isSuppressGetOrderDetails: getIsSuppressGetOrderDetails(state),
    isVenmoAppInstalled: isVenmoAppInstalled(state),
    isVenmoEnabled: getIsVenmoEnabled(state),
    isAvoidGetOrderDetails: getIsAvoidGetOrderDetails(state),
    enableKeepShoppingCTA: getEnableKeepShoppingCTA(state),
    multipackProductType: getMultipackProductType(state),
    isABTestOffStyleWith: getABTestOffStyleWith(state),
    isPhysicalMpackEnabled: getIsPhysicalMpackEnabled(state),
    addedToBagGhostLoaderState: getAddedToBagGhostLoaderState(state),
    addedToBagGhostLoaderCompleteState: getAddedToBagGhostLoaderCompleteState(state),
    isMpackItem: getIsMpackItem(state),
    userDefaultStore: defaultStore,
    bopisItemInventory: PickupSelectors.getBopisItemInventory(state),
    addToPickupError: getAddedToPickupError(state),
    showBOPISPickupInstead: getEnableBOPISPickupInstead(state),
    isABTestHidePoints: getIsATBHidePoints(state),
    isOptmisticAddToBagModal: !!getOptimisticAddBagModal(state),
    isUserGuest: getIsGuest(state),
    isRememberedUserState: isRememberedUser(state),
    addedToBagError: getAddedToBagError(state),
    isNewReDesignEnabled: getIsNewReDesignEnabled(state),
    isATBModalBackAbTestNewDesign: getIsATBModalBackAbTestNewDesign(state),
    loyaltyAPICallStatus: getLoyaltyAPICallStatus(state),
    aTbAPICallStatus: getATbAPICallStatus(state),
    aTbMaintenanceStatus: getATBMaintenanceStatus(state),
    isPlcc: isPlccUser(state),
    alternateBrand: getAlternateBrandName(state),
    alternateBrandFromPickup: getAlternateBrand(state),
    isFBTAbTestEnabled: getIsFBTAbTestEnabled(state),
    isFBTDisplayed: getFbtDisplayedState(state),
    isFbtCompleted: getIsFbtCompletedState(state),
    itemInfo: getATBItemInfo(state),
    isFBTEnabled: getIsFbtEnabledState(state),
    isAddedToBagRedesignEnabled: getIsAddedToBagRedesignEnabled(state),
    loyaltyOrderItems: getLoyaltyPointsRequestPayload(state),
    loyaltyOrderItemPoints: getLoyaltyOrderItemPoints(state),
    isLoyaltyTieringEnabled: getIsLoyaltyTieringEnabled(state),
    isOffersDisplayEnabled: getIsOffersDisplayEnabled(state),
    currencyAttributes: getCurrencyAttributes(state),
    addToBagMultipleItemError: getMultipleItemsAddedToBagError(state) || {},
    isLoyaltyPointsEnabled: getIsPersistPointsApiEnabled(state),
    firstTouchValue: getFirstTimeCaptureBanner(state),
    firstTouchShopMenu: getFirstTimeCaptureShopMenu(state),
    payloadItemCount: getAddedToBagPayloadItemCount(state),
    isBundleTrackerEnabled: getIsBundleTrackerEnabled(state),
    isFavoritePage: getFavoritePage(state),
    isSyteEnabled: getIsSyteEnabled(state),
    userId: getUserId(state),
    isUserPersonalizationEnabled: getIsUserPersonalizationEnabled(state),
    isUserPersonalizationApiEnabled: getUserPersonalizationApiEnabled(state),
    isUserLoggedIn: getUserLoggedInState(state),
    placePerkEnabled: isPlacePerkEnabled(state),
    displayThreshold: getPlacePerksDisplayThreshold(state),
    spendLeftForNextPerk: getSpendLeftForNextPerk(state),
    IsAppRatingPromptEnabled: getIsAppRatingPromptEnabled(state),
    isHardcodeSizeMapEnabled: getIsHardcodeSizeMapEnabled(state),
    hardcodeSizeMapConfig: getHardcodeSizeMapConfig(state),
    shipments: getOrderShipments(state),
    productTotal: getProductTotal(state),
    freeShippingThreshold: getFreeShippingThresholdValue(state),
    dynamicShippingCharge: getDynamicShippingCharge(state),
    shippingMethodSelected: checkoutSelectors.getSavedShippingMethod(state),
    isFreeShippingProgressBarDisabled: getIsFreeShippingProgressBarDisabled(state),
    isShippingOrder: isECOMStatus(state) || isMixedOrderStatus(state) || false,
    isMixedOrder: isMixedOrderStatus(state),
    isNewATBProductInformationDesignEnabled: getIsNewATBProductInformationDesign(state),
    isFreeShippingCouponApplied: getIsFreeShippingCouponApplied(state),
    isQvModalOpen: getIsQVOpen(state),
    offerPriceIsLoading: getOfferPriceIsLoading(state),
    freeShippingPromoType: getFreeShippingType(state),
    freeShippingMessageForPromosEnabled: freeShippingMessageForPromos(state),
    isBackToQuickviewCTAEnabled: getIsBackToQuickviewCTAEnabled(state),
    atbUnavailableProducts: getATBUnavailableProducts(state),
    newGlobalErrorMessageEnabled: getNewGlobalErrorMessage(state),
    isInventoryUnavailable: getIsInventoryUnavailable(state),
    serverTime: getServerTimeFromState(state),
    isDyEnabled: getIsDyEnabled(),
    atb1Rec: getATB1Rec(state),
  };
};

AddedToBagContainer.propTypes = {
  addedToBagData: PropTypes.shape({}).isRequired,
  addToBagModalError: PropTypes.string,
  router: PropTypes.shape({}).isRequired,
  quantity: PropTypes.number.isRequired,
  isInternationalShipping: PropTypes.bool.isRequired,
  addedToBagLoaderState: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  clearModalError: PropTypes.func,
  pointsSummary: PropTypes.shape({}).isRequired,
  bagLoading: PropTypes.bool.isRequired,
  isBossEnabled: PropTypes.bool.isRequired,
  isSuppressGetOrderDetails: PropTypes.bool.isRequired,
  navigation: PropTypes.shape({}).isRequired,
  isOpenDialog: PropTypes.bool.isRequired,
  isOpenAddedToBagMinimal: PropTypes.shape({}),
  isPayPalWebViewEnable: PropTypes.bool.isRequired,
  isPayPalButtonRendered: PropTypes.bool.isRequired,
  isPayPalEnabled: PropTypes.bool.isRequired,
  addedToBagInterval: PropTypes.func.isRequired,
  totalBagItems: PropTypes.shape([]).isRequired,
  isVenmoAppInstalled: PropTypes.bool.isRequired,
  isVenmoEnabled: PropTypes.bool.isRequired,
  isAvoidGetOrderDetails: PropTypes.bool.isRequired,
  enableKeepShoppingCTA: PropTypes.bool.isRequired,
  multipackProductType: PropTypes.string,
  isABTestOffStyleWith: PropTypes.bool,
  isPhysicalMpackEnabled: PropTypes.bool,
  addedToBagGhostLoaderState: PropTypes.bool,
  isMpackItem: PropTypes.bool,
  addedToBagGhostLoaderCompleteState: PropTypes.bool,
  getBopisInventoryDetails: PropTypes.func,
  userDefaultStore: PropTypes.shape({}),
  bopisItemInventory: PropTypes.shape({}),
  addItemToCartInPickup: PropTypes.func,
  addToPickupError: PropTypes.string,
  setAddToPickupError: PropTypes.func,
  showBOPISPickupInstead: PropTypes.bool,
  isABTestHidePoints: PropTypes.bool,
  isUserGuest: PropTypes.bool,
  isRememberedUserState: PropTypes.bool,
  getFavoriteStore: PropTypes.func,
  addedToBagError: PropTypes.string,
  isOptmisticAddToBagModal: PropTypes.bool,
  isNewReDesignEnabled: PropTypes.bool,
  isOpenDialogMinimal: PropTypes.shape({}),
  isATBModalBackAbTestNewDesign: PropTypes.bool,
  loyaltyAPICallStatus: PropTypes.bool,
  aTbAPICallStatus: PropTypes.bool,
  addToBagEcomNewAfterModalOpened: PropTypes.func,
  openStatePayloadData: PropTypes.shape({}),
  isPlcc: PropTypes.bool,
  isAddedToBagRedesignEnabled: PropTypes.bool,
  addToBagMultipleItemError: PropTypes.shape({}),
  isLoyaltyPointsEnabled: PropTypes.bool,
  isFavoritePage: PropTypes.bool,
  isUserPersonalizationEnabled: PropTypes.bool,
  isUserPersonalizationApiEnabled: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool,
  placePerkEnabled: PropTypes.bool,
  IsAppRatingPromptEnabled: PropTypes.bool,
  displayThreshold: PropTypes.number,
  spendLeftForNextPerk: PropTypes.number,
  isHardcodeSizeMapEnabled: PropTypes.bool,
  hardcodeSizeMapConfig: PropTypes.shape({}),
  isQvModalOpen: PropTypes.bool,
  closeQvModal: PropTypes.func,
  isBackToQuickviewCTAEnabled: PropTypes.bool,
};

AddedToBagContainer.defaultProps = {
  multipackProductType: null,
  isABTestOffStyleWith: false,
  isPhysicalMpackEnabled: false,
  addedToBagGhostLoaderState: false,
  isMpackItem: false,
  addedToBagGhostLoaderCompleteState: false,
  getBopisInventoryDetails: () => {},
  userDefaultStore: {},
  bopisItemInventory: {},
  addItemToCartInPickup: () => {},
  addToPickupError: '',
  setAddToPickupError: () => {},
  showBOPISPickupInstead: false,
  isABTestHidePoints: false,
  isUserGuest: true,
  isRememberedUserState: false,
  getFavoriteStore: () => {},
  addedToBagError: '',
  isOptmisticAddToBagModal: false,
  isNewReDesignEnabled: true,
  isOpenAddedToBagMinimal: {},
  isOpenDialogMinimal: {},
  addToBagModalError: null,
  clearModalError: () => {},
  isATBModalBackAbTestNewDesign: false,
  loyaltyAPICallStatus: false,
  aTbAPICallStatus: false,
  addToBagEcomNewAfterModalOpened: () => {},
  openStatePayloadData: {},
  isPlcc: false,
  isAddedToBagRedesignEnabled: false,
  addToBagMultipleItemError: {},
  isLoyaltyPointsEnabled: false,
  isFavoritePage: false,
  isUserPersonalizationEnabled: false,
  isUserPersonalizationApiEnabled: false,
  isUserLoggedIn: false,
  placePerkEnabled: false,
  IsAppRatingPromptEnabled: false,
  displayThreshold: 25,
  spendLeftForNextPerk: 0,
  isHardcodeSizeMapEnabled: false,
  hardcodeSizeMapConfig: {},
  isQvModalOpen: false,
  closeQvModal: () => {},
  isBackToQuickviewCTAEnabled: false,
};

const withReducer = withDynamicReducer([
  { key: 'CartItemTileReducer', reducer: CartTileReducer },
  { key: 'AddedToBagReducer', reducer: AddedToBagReducer },
  { key: PRODUCT_PICKUP_REDUCER_KEY, reducer: ProductPickupReducer },
]);
const withSaga = withDynamicSaga([
  { key: 'CartPageSaga', saga: CartPageSaga },
  { key: 'ProductPickupStoreSaga', saga: ProductPickupStoreSaga },
  { key: 'AddedToBagSaga', saga: AddedToBagSaga },
]);
export default compose(
  withReducer,
  withSaga,
  connect(mapStateToProps, mapDispatchToProps)
)(AddedToBagContainer);
